var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("@/assets/icons/pulse_ai_icon.png"),"alt":"pulse ai icon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }